export const MiniMicIconHover = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 1.25C9.37665 1.25 7.25 3.37665 7.25 6V10C7.25 12.6234 9.37665 14.75 12 14.75C14.6234 14.75 16.75 12.6234 16.75 10V6C16.75 3.37665 14.6234 1.25 12 1.25Z"
        fill="#245cea"
      />
      <path
        d="M4.75 10C4.75 9.58579 4.41421 9.25 4 9.25C3.58579 9.25 3.25 9.58579 3.25 10C3.25 14.5798 6.7686 18.3379 11.25 18.7183V20.953C11.0336 20.9815 10.8183 21.0223 10.6054 21.0756L9.8181 21.2724C9.41625 21.3729 9.17193 21.7801 9.27239 22.1819C9.37285 22.5837 9.78006 22.8281 10.1819 22.7276L10.9692 22.5308C11.3076 22.4462 11.6538 22.4039 12 22.4039C12.3462 22.4039 12.6924 22.4462 13.0308 22.5308L13.8181 22.7276C14.2199 22.8281 14.6271 22.5837 14.7276 22.1819C14.8281 21.7801 14.5837 21.3729 14.1819 21.2724L13.3946 21.0756C13.1817 21.0223 12.9664 20.9815 12.75 20.953V18.7183C17.2314 18.3379 20.75 14.5798 20.75 10C20.75 9.58579 20.4142 9.25 20 9.25C19.5858 9.25 19.25 9.58579 19.25 10C19.25 14.0041 16.0041 17.25 12 17.25C7.99594 17.25 4.75 14.0041 4.75 10Z"
        fill="#245cea"
      />
    </svg>
  );
};
